import React, { Suspense } from "react";

import { css } from "@emotion/css";
import { QueryAwait } from "@steto-care/steto-query";
import { Outlet } from "@tanstack/react-router";

import { usePatientIdFromURL } from "@/hooks/usePatientIdFromURL.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { CenteredLoader } from "@/uiKit/atoms/Loader.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";
import { PageWithDrawer } from "@/uiKit/atoms/page/PageWithDrawer.tsx";
import { SuspenseWithError } from "@/uiKit/atoms/SuspenseWithError.tsx";
import { MessagingDrawer } from "@/uiKit/organisms/ChatMessaging/MessagingDrawer.tsx";
import { OpenMessagesFloatingButton } from "@/uiKit/organisms/ChatMessaging/OpenMessagesFloatingButton.tsx";
import { HandledErrorCard } from "@/uiKit/organisms/HandledErrorCard.tsx";
import {
  PatientNavigationHeader,
  PatientNavigationHeaderSkeleton,
} from "@/uiKit/organisms/PatientNavigationHeader.tsx";
import { ValidateIdentityDrawer } from "@/uiKit/organisms/ValidateIdentityDrawer.tsx";

export const PractitionerManagePatientTemplate: React.FC = () => {
  const styles = useStyles(makeStyles);
  const patientId = usePatientIdFromURL();

  return (
    <>
      <title>{`Stēto - ${patientId.slice(0, 8)}`}</title>
      <Suspense fallback={<PatientNavigationHeaderSkeleton />}>
        <PatientNavigationHeader />
      </Suspense>
      <QueryAwait errorFallback={() => null} pendingFallback={() => null}>
        <ValidateIdentityDrawer />
      </QueryAwait>
      <section id="manage-patient-layout-main" className={styles.main}>
        <SuspenseWithError errorFallback={HandledErrorCard} pendingFallback={CenteredLoader}>
          <PageWithDrawer
            id="patient-page"
            drawer={<MessagingDrawer />}
            floatingAction={<OpenMessagesFloatingButton />}
          >
            <PageContent className={styles.content}>
              <Outlet />
            </PageContent>
          </PageWithDrawer>
        </SuspenseWithError>
      </section>
    </>
  );
};

const makeStyles = () => ({
  content: css({
    display: "flex",
    flexDirection: "column",
    flex: "1 1",
    overflow: "hidden",
  }),
  main: css({
    display: "flex",
    flexDirection: "column",
  }),
});
